import { cn, Text } from "@aurem/ui";
import { BottomNavigationItem } from "../types";

type Props = {
  item: BottomNavigationItem;
};

export const BottomNavigationButton = ({ item }: Props) => {
  return (
    <button
      key={item.id}
      onClick={item.onClick}
      className={cn(
        "flex flex-col justify-center items-center gap-1 w-[20%] min-w-[3.75rem] h-full shrink-0 text-white",
      )}
    >
      <span
        className={cn(
          "flex items-center justify-center w-8 h-8 shrink-0 rounded-md",
          item.active ? "bg-white text-accent-500" : "bg-transparent",
        )}
      >
        {item.icon}
      </span>
      <Text size="xs" weight="medium">
        {item.text}
      </Text>
    </button>
  );
};
